import React from "react";
import { useSharedSections } from "@/lib/useSharedSections";
import { fillFirm } from "@/lib/sharedSectionDefaults";

export const Disclaimer = ({ text }) => {
  const i = (text || "").indexOf(". ");
  if (i < 0) return text || null;
  return <><strong>{text.slice(0, i + 1)}</strong>{" "}{text.slice(i + 2)}</>;
};

export const SharedTrustBar = ({ renderIcon }) => {
  const s = useSharedSections();
  return (
    <section className="lp-trustbar" aria-label="Why choose us" data-testid="lp-trustbar">
      <div className="lp-trustbar-inner">
        {s.trust_badges.map((b, i) => (
          <div className="lp-trust-item" key={i} data-testid={`lp-trust-item-${i}`}>
            {renderIcon?.(i)}
            <div className="lp-trust-title">{b.title}</div>
            <div className="lp-trust-sub">{b.sub}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export const SharedCaseResults = ({ sub, testId }) => {
  const s = useSharedSections();
  if (!s.case_results.length) return null;
  return (
    <section className="lp-section" aria-label="Recent case results" data-testid={testId}>
      <div className="lp-eyebrow">Recent case results</div>
      <h2 className="lp-section-title">Results our network has secured for clients</h2>
      {sub && <p className="lp-section-sub">{sub}</p>}
      <div className="lp-results-grid">
        {s.case_results.map((r, i) => (
          <div className="lp-result-card" key={i} data-testid={`lp-result-${i}`}>
            <div className="lp-result-amount">{r.amount}</div>
            <div className="lp-result-label">{r.label}</div>
          </div>
        ))}
      </div>
      <div className="lp-results-disclaimer"><Disclaimer text={s.results_disclaimer} /></div>
    </section>
  );
};

export const SharedHowSteps = ({ fallback }) => {
  const s = useSharedSections();
  const steps = s.how_it_works || fallback;
  return (
    <div className="lp-steps" data-testid="lp-how-steps">
      {steps.map((st, i) => (
        <div className="lp-step" key={i}>
          <div className="lp-step-num">{String(i + 1).padStart(2, "0")}</div>
          <div className="lp-step-title">{st.title}</div>
          <div className="lp-step-desc">{st.body}</div>
        </div>
      ))}
    </div>
  );
};

// Final call-to-action wording: the admin's shared copy when set, else the page's own.
export function useFinalCta(firm, defaults) {
  const cta = useSharedSections().final_cta;
  if (!cta) return defaults;
  return {
    title: fillFirm(cta.title, firm),
    sub: cta.body ? fillFirm(cta.body, firm) : defaults.sub,
    button: cta.button || defaults.button,
  };
}
